import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  Divider,
  Autocomplete,
  FormHelperText,
  CircularProgress,
  Chip,
  Tooltip,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import EditUserPurchasesValidationSchema from ".././Validations/BannerValidation";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import {
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
  BUTTON_STYLES,
  FORM_STYLES,
} from "../../styles/componentStyles";
import FilterBar from "../Reusable/FilterBar";
import BookList from "../BookList";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

function EditPurchased({
  open,
  onClose,
  userList,
  selectedUser,
  setRefreshList,
}) {
  const [universityList, setUniversityList] = useState([]);
  const [courseList, setCourseList] = useState([]);

  const [adminUsers, setAdminUsers] = useState([]);
  const [adminUsersPage, setAdminUsersPage] = useState(0);
  const [adminUsersTotalPages, setAdminUsersTotalPages] = useState(0);
  const [adminUsersQuery, setAdminUsersQuery] = useState("");
  const [selectedAdminUser, setSelectedAdminUser] = useState(null);
  const [adminUsersLoading, setAdminUsersLoading] = useState(false);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [semesterId, setSemesterId] = useState("");
  const [regulationId, setRegulationId] = useState("");
  const [books, setBooks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isOrderEditable, setIsOrderEditable] = useState(false);
  const [copied, setCopied] = useState(false);
  console.log(userList?.bookId);

  const handleCopy = () => {
    navigator.clipboard.writeText("order_M4NUALXBC12YZ");
    setCopied(true);

    setTimeout(() => setCopied(false), 1500); // hide after 1.5 sec
  };
  // UserList data through update the state.
  useEffect(() => {
    if (!Array.isArray(selectedUser) || selectedUser.length === 0) return;

    const user = selectedUser[0];

    setUniversityId(user.universityId || "");
    setCourseId(user.courseId || "");
    setRegulationId(user.regulationId || "");
    setSemesterId(user.semesterId || "");
  }, [selectedUser]);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      userId: userList?.userId || "",
      purchaseId: userList?.purchaseId || "",
      bookId: userList?.bookId || 0,
    },

    validationSchema:
      EditUserPurchasesValidationSchema.EditUserPurchasesValidationSchema,
    enableReinitialize: true,

    onSubmit: async (values, { resetForm }) => {
      console.log(values);
      try {
        let response;
        // If it's Edit data it will call Update api
        // if (notificationEdit?.id) {
        //   response = await api.put(
        //     `/api/v1/update-news/${notificationEdit?.id}`,
        //     values
        //   );
        // }
        // Else it's Add data it will call Add api

        console.log(values);
        response = await api.put(
          `/api/userDetails/swapUserPurchases/${userList?.purchaseId}`,
          values
        );

        // Show success toast
        toast.success(`User Purchased books added successfully!`, {
          position: "top-right",
          autoClose: 2000,
        });
        // onSuccess(response.data.data);
        resetForm();
        onClose();
        setRefreshList((prev) => prev + 1);
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      }
    },
  });

  useEffect(() => {
    setBooks([]);
    if (
      universityId === "" &&
      courseId === "" &&
      regulationId === "" &&
      semesterId === ""
    )
      return;

    setIsLoading(true);

    api
      .get("/api/v1/allBooks", {
        params: {
          universityId: universityId,
          courseId: courseId,
          regulationId: regulationId,
          semesterId: semesterId,
        },
      })
      .then((res) => setBooks(res.data.data))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, [universityId, courseId, regulationId, semesterId]);

  //  Automatically calculate expiryDate when purchaseDate changes
  //   useEffect(() => {
  //     if (formik.values.purchaseDate) {
  //       const purchaseDate = new Date(formik.values.purchaseDate);
  //       const expiryDate = new Date(purchaseDate);

  //       // Example: Add 1 year (you can change this to months/days)
  //       expiryDate.setMonth(expiryDate.getMonth() + 6);

  //       // Convert to yyyy-mm-dd format for input
  //       const formattedDate = expiryDate.toISOString().split("T")[0];

  //       // Only update if different (to prevent re-renders)
  //       if (formik.values.expiryDate !== formattedDate) {
  //         formik.setFieldValue("expiryDate", formattedDate);
  //       }
  //     }
  //   }, [formik.values.purchaseDate]);
  //   const memoizedBooks = useMemo(() => books, [books]);

  //   const getMinExpiryDate = (purchaseDate) => {
  //     if (!purchaseDate) return "";
  //     const date = new Date(purchaseDate);
  //     date.setMonth(date.getMonth() + 6);
  //     return date.toISOString().split("T")[0];
  //   };
  const PurchasesFile = "PurchasedUsers";
  return (
    <>
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {"Edit User Purchased Book"}
          </Typography>

          <Box sx={FORM_STYLES.container}>
            <TextField
              size="small"
              disabled
              label="User Id"
              name="userId"
              value={formik.values.userId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.userId && Boolean(formik.errors.userId)}
              helperText={formik.touched.userId && formik.errors.userId}
              {...TEXT_FIELD_STYLES.standard}
              required
              sx={{
                mb: 2,
                ...TEXT_FIELD_STYLES.standard?.sx,
              }}
            />
            <TextField
              size="small"
              disabled
              label="Purchase Id"
              name="purchaseId"
              value={formik.values.purchaseId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.purchaseId && Boolean(formik.errors.purchaseId)
              }
              helperText={formik.touched.purchaseId && formik.errors.purchaseId}
              {...TEXT_FIELD_STYLES.standard}
              required
              sx={{
                mb: 2,
                ...TEXT_FIELD_STYLES.standard?.sx,
              }}
            />
            <FilterBar
              universityId={universityId}
              courseId={courseId}
              semesterId={semesterId}
              regulationId={regulationId}
              setUniversityId={setUniversityId}
              setCourseId={setCourseId}
              setSemesterId={setSemesterId}
              setRegulationId={setRegulationId}
              PurchasesFile={PurchasesFile}
            />
            <Box sx={FORM_STYLES.row}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  key={`${universityId}-${courseId}-${regulationId}-${semesterId}`}
                  size="small"
                  options={books}
                  name="bookId"
                  disabled={isLoading}
                  loading={isLoading}
                  loadingText="Loading books..."
                  getOptionLabel={(option) => `${option.id} ${option.title}`}
                  value={
                    books.find((book) => book.id === formik.values.bookId) ||
                    null
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue("bookId", newValue ? newValue.id : 0);
                  }}
                  onBlur={() => formik.setFieldTouched("bookId", true)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      {...TEXT_FIELD_STYLES.standard}
                      label="Select Book"
                      placeholder="Choose a book"
                      error={
                        formik.touched.bookId && Boolean(formik.errors.bookId)
                      }
                      helperText={formik.touched.bookId && formik.errors.bookId}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {isLoading && (
                              <CircularProgress size={20} sx={{ mr: 2 }} />
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  sx={{
                    backgroundColor: "background.paper",
                    borderRadius: 2,
                  }}
                />
              </FormControl>
            </Box>

            {/* <Box sx={FORM_STYLES.row}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TextField
                  size="small"
                  label="Order Id"
                  disabled={!isOrderEditable}
                  name="orderId"
                  value={formik.values.orderId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.orderId && Boolean(formik.errors.orderId)
                  }
                  helperText={formik.touched.orderId && formik.errors.orderId}
                  {...TEXT_FIELD_STYLES.standard}
                  sx={{
                    ...TEXT_FIELD_STYLES.standard.sx,
                    ...FORM_STYLES.field.sx,
                    width: "90%",
                  }}
                />
                <Tooltip title="Edit Order ID">
                  <EditIcon
                    onClick={() => setIsOrderEditable(true)}
                    sx={{
                      color: "#17479e",
                      cursor: "pointer",
                      padding: "6px",
                      marginTop: "10px",
                      borderRadius: "50%",
                      transition: "0.2s",
                      "&:hover": {
                        backgroundColor: "rgba(23, 71, 158, 0.1)",
                      },
                    }}
                  />
                </Tooltip>
              </Box>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
              >
                <Typography sx={{ fontSize: "13px", color: "gray" }}>
                  Suggested order_id: " order_M4NUALXBC12YZ "
                </Typography>

                <ContentCopyIcon
                  sx={{
                    fontSize: 16,
                    cursor: "pointer",
                    color: "#17479e",
                    "&:hover": { color: "#0d2f6b" },
                  }}
                  onClick={handleCopy}
                />
                {copied && (
                  <Typography sx={{ fontSize: "12px", color: "green" }}>
                    Copied!
                  </Typography>
                )}
              </Box>
              <TextField
                size="small"
                label="Purchase Date"
                name="purchaseDate"
                type="date"
                value={formik.values.purchaseDate}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.purchaseDate &&
                  Boolean(formik.errors.purchaseDate)
                }
                helperText={
                  formik.touched.purchaseDate && formik.errors.purchaseDate
                }
                InputLabelProps={{ shrink: true }}
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />

              <TextField
                size="small"
                label="Expiry Date"
                name="expiryDate"
                type="date"
                value={formik.values.expiryDate}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                inputProps={{
                  min: getMinExpiryDate(formik.values.purchaseDate),
                }}
                error={
                  formik.touched.expiryDate && Boolean(formik.errors.expiryDate)
                }
                helperText={
                  formik.touched.expiryDate && formik.errors.expiryDate
                }
                InputLabelProps={{ shrink: true }}
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />
            </Box> */}
            {/* <Box sx={FORM_STYLES.row}>
              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
                size="small"
              >
                <InputLabel>Active</InputLabel>
                <Select
                  label="Active"
                  name="active"
                  value={formik.values.active}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.active && Boolean(formik.errors.active)}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
                {formik.touched.active && formik.errors.active && (
                  <FormHelperText sx={{ color: "#d9322f" }}>
                    {formik.errors.active}
                  </FormHelperText>
                )}
              </FormControl>
            </Box> */}
          </Box>

          <Box
            sx={FORM_STYLES.actions}
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
              Cancel
            </Button>
            <Button type="submit" {...BUTTON_STYLES.primary}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default EditPurchased;
